import {Component, Inject, Input, Injectable} from '@angular/core';
import {FieldEditingService} from "@/angular-blocworx/components/fields/fieldEditing/field-editing.service";
import {BaseFieldsComponent} from "@/angular-blocworx/components/fields/BaseFieldsComponent";
import {DataGeneratorService} from "@/angular-blocworx/components/fields/data-generator/data-generator.service";
import {of} from "rxjs";

@Component({
    selector: 'data-generator-create-edit-popup',
    templateUrl: 'angular-blocworx/components/fields/data-generator/templates/create-edit/popup.html',
    styleUrls: ['angular-blocworx/components/fields/data-generator/data-generator.component.scss'],
})

export class DataGeneratorCreateEditPopup extends BaseFieldsComponent {

    @Input() fc;
    @Input() scanStation;
    dataGeneratorBlocList: []
    dataGeneratorBlocListDestination: []
    dataGeneratorBlocFieldList: []
    dataGeneratorBlocFieldList_byFieldId: [];
    dataGeneratorBlocFieldListForDestination: []
    dataGeneratorBlocFieldListForDestination_byFieldId: [];
    fcInitialFieldParameterArrays: Record<string, any[]> = {};
    localFieldMatchingFieldPairsLocalSelectedFieldId: string;
    localFieldMatchingFieldPairsRemoteSelectedFieldId: string;
    selectedDataGeneratorOnlyApplyFieldActionsFieldId: string;
    selectedDataGeneratorOnlyShowFieldId: string
    selectedFieldToRefreshAfterCompletionId: string;
    chosenValue: string;
    selectedColourForValue: string;
    selectedFieldIdNotToReplace: string;


    constructor(
        @Inject(DataGeneratorService) private dataGeneratorService: DataGeneratorService,
        @Inject(FieldEditingService) private fieldEditingService: FieldEditingService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.scanStation.activeField = 'data-generator'
        await this.initialiseFieldParametersFromValues()
        let job = {
            "id": this.scanStation.scanStationObj.jobID,
            "title": ""
        };

        this.setModuleToLoad('dataGeneratorBlocList', 'dataGeneratorStationAndFields', job, false);
        this.setModuleToLoad('dataGeneratorBlocListDestination', 'dataGeneratorDestinationStationAndFields', job, true);
    }

    async initialiseFieldParametersFromValues(): Promise<void> {
        this.scanStation.externalJobs = {};

        const defaultFieldParameterObject: object = this.dataGeneratorService.getInitialParams();

        this.fc.initialFieldParams = this.dataGeneratorService.initiateAllFieldParametersFromValues(this.fc.initialFieldParams, defaultFieldParameterObject);

        this.fcInitialFieldParameterArrays['localFieldMatchingFieldPairs'] = Object.values(this.fc.initialFieldParams['localFieldMatchingFieldPairs']);
        this.fcInitialFieldParameterArrays['sourceDestinationFieldMatchingPairs'] = Object.values(this.fc.initialFieldParams['sourceDestinationFieldMatchingPairs']);
        this.fcInitialFieldParameterArrays['localDestinationFieldMatchingPairs'] = Object.values(this.fc.initialFieldParams['localDestinationFieldMatchingPairs']);
        this.fcInitialFieldParameterArrays['fieldsToRefreshAfterCompletion'] = Object.values(this.fc.initialFieldParams['fieldsToRefreshAfterCompletion']);
        this.fcInitialFieldParameterArrays['onlyApplyFieldActionsFieldArray'] = Object.values(this.fc.initialFieldParams['onlyApplyFieldActionsFieldArray']);
        this.fcInitialFieldParameterArrays['recurringDataAffectedResultsBoxes'] = Object.values(this.fc.initialFieldParams['recurringDataAffectedResultsBoxes'])
        this.fcInitialFieldParameterArrays['onlyApplyFieldActionsFieldArrayAfterLines'] = Object.values(this.fc.initialFieldParams['onlyApplyFieldActionsFieldArrayAfterLines'])


        this.forceArrayFromObjectOrArray('onlyApplyFieldActionsFieldArray');

        if(this.fc.initialFieldParams.dataGeneratorStationAndFields.stationId != "") {
            await this.getFieldsFromBlocId('dataGeneratorBlocFieldList', this.fc.initialFieldParams.dataGeneratorStationAndFields.stationId)
        }

        if(this.fc.initialFieldParams.dataGeneratorDestinationStationAndFields.stationId != "") {
            await this.getFieldsFromBlocId('dataGeneratorBlocFieldListForDestination', this.fc.initialFieldParams.dataGeneratorDestinationStationAndFields.stationId)
        }


    }

    forceArrayFromObjectOrArray = (fieldParameter) => {
        if(Array.isArray(this.fc.initialFieldParams[fieldParameter])) {
            this.fcInitialFieldParameterArrays[fieldParameter] = this.fc.initialFieldParams[fieldParameter];
        } else {
            this.fcInitialFieldParameterArrays[fieldParameter] = Object.values(this.fc.initialFieldParams[fieldParameter]);
        }
    }

    async getFieldsFromBlocId(parameterFieldList, blocId) {

        let fieldList = await this.fieldEditingService.getFieldsForBlocIdForFieldEditing(blocId);

        if (fieldList.scanStationFields != null) {
            this[parameterFieldList] = fieldList.scanStationFields;
        }

        this[parameterFieldList + '_byFieldId'] = this[parameterFieldList].reduce((acc, cur) => {
            acc[cur.id] = cur;
            return acc;
        }, {});

    }

    async setModuleToLoad(blocListName, moduleFieldParameter, job, secondInstanceOfDirective = false) {

        if (this.fc.initialFieldParams[moduleFieldParameter] == null) {
            this.fc.initialFieldParams[moduleFieldParameter] = {
                "jobId": job.id
            };
        } else {
            this.fc.initialFieldParams[moduleFieldParameter].jobId = job.id;
        }

        let blocListRequest = await this.fieldEditingService.getBlocsFromModuleSelection(moduleFieldParameter, this.fc.initialFieldParams, this.fc.currentJobId);
        if (blocListRequest.data != null) {
            this[blocListName] = blocListRequest.data;
        }

        if (secondInstanceOfDirective == false) {
            this.scanStation.externalJobs = {};
            this.scanStation.externalJobKeyWord = job.title
        } else {
            this.scanStation.externalJobsTwo = {};
            this.scanStation.externalJobKeyWordTwo = job.title
        }
    }

    addOrRemoveLocalAndRemoteMatchingFieldPairs(fieldParameter, action, localFieldId, remoteFieldId, index = null, usage) {
        this.fc.initialFieldParams[fieldParameter] = this.fieldEditingService.addOrRemoveLocalAndRemoteMatchingFieldPairs(this.fc.initialFieldParams[fieldParameter], action, localFieldId, remoteFieldId, index, usage);
        this.fcInitialFieldParameterArrays[fieldParameter] = Object.values(this.fc.initialFieldParams[fieldParameter]);
    }


    convertObjectToArray(object: object): any[] {
        if (object != null) {
            return Object.values(object);
        }
    }

    async ngAfterViewInit(): Promise<void> {

    }

    applyingFieldActions = () => {
        if (
            this.fc.initialFieldParams.dataGeneratorEditorApplyBlocInitialisation == 1 ||
            this.fc.initialFieldParams.dataGeneratorApplyFieldActions == 1 ||
            this.fc.initialFieldParams.dataGeneratorPreSubmitFeatures == 1)
        {
            return true;

        } else {
            return false;
        }
    }

    addSingleFieldList = (fieldParameter, fieldId) => {
        this.fc.initialFieldParams[fieldParameter] = this.fieldEditingService.addSingleFieldList(this.fc.initialFieldParams[fieldParameter], fieldId);
        this.forceArrayFromObjectOrArray(fieldParameter);
    }

    removeFromSingleFieldList = (fieldParameter, index) => {
        this.fc.initialFieldParams[fieldParameter] = this.fieldEditingService.removeFromFieldList(this.fc.initialFieldParams[fieldParameter],index);
        this.forceArrayFromObjectOrArray(fieldParameter);
    }

    /**
     * This function checks if its a field type that might get refreshed when something else happens in the bloc
     * @param field
     */
    isRefreshableListTypeField = (field) => {
        return (field.field_type == 'dropdown-from-station' || field.field_type == 'radio-buttons-from-station'
            || field.field_type == 'autocomplete-field' || field.field_type == 'checkbox-buttons-from-station' || field.autocomplete == 1
            || field.field_type == 'results-box');
    }



    resetListsRelatedToSelectBloc = () => {
        this.fc.initialFieldParams['localFieldMatchingFieldPairs'] = {};
        this.fcInitialFieldParameterArrays['localFieldMatchingFieldPairs'] = [];

        this.localFieldMatchingFieldPairsRemoteSelectedFieldId = null;
        this.fc.initialFieldParams.dataGeneratorStationAndFields.sortByFieldId = null;
        this.selectedDataGeneratorOnlyShowFieldId = null;
        this.selectedDataGeneratorOnlyApplyFieldActionsFieldId = null;

        this.fc.initialFieldParams['onlyApplyFieldActionsFieldArray'] = [];
        this.fcInitialFieldParameterArrays['onlyApplyFieldActionsFieldArray'] = [];

        this.fc.initialFieldParams['onlyShowFieldArray'] = [];
        this.fcInitialFieldParameterArrays['onlyShowFieldArray'] = [];

    }




}
